import { render, staticRenderFns } from "./WithoutAssignmentEntriesView.vue?vue&type=template&id=2a9c258c"
import script from "./WithoutAssignmentEntriesView.vue?vue&type=script&lang=js"
export * from "./WithoutAssignmentEntriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports